import Vue from 'vue';
import Vuex from 'vuex';

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    unique_key: JSON.parse(localStorage.getItem('unique_key')) || Math.floor(Math.random() * 10000000),
    currentQuestion: JSON.parse(localStorage.getItem('currentQuestion')) || 1,
    answers: JSON.parse(localStorage.getItem('answers')) || {
      question_1: [],
      question_1_errors: false,
      question_2: 15,
      question_3: '',
      question_3_errors: false,
      question_4: '',
      question_4_errors: false,
      question_5: '',
      question_5_errors: false,
      question_6: '',
      question_6_errors: false,
    },
    products: JSON.parse(localStorage.getItem('products')) || [],
  },
  mutations: {
    currentQuestion(state, value) {
      state.currentQuestion = value;
      localStorage.setItem('currentQuestion', JSON.stringify(value));
    },
    answers(state, value) {
      state.answers = value;
      localStorage.setItem('answers', JSON.stringify(value));
    },
    products(state, value) {
      state.products = value;
      localStorage.setItem('products', JSON.stringify(value));
    },
  },
  actions: {
  },
  modules: {
  },
});
